// extracted by mini-css-extract-plugin
module.exports = {"datepickerSelected":"_3zzZe","datepickerToday":"_2mlgT"};